module.exports = __webpack_public_path__ + "static/media/OfAFeatherBookCover.d625b104.jpg";